import { render } from "./create-password.vue?vue&type=template&id=79cf9a48&scoped=true&ts=true&lang=pug"
import script from "./create-password.vue?vue&type=script&lang=ts"
export * from "./create-password.vue?vue&type=script&lang=ts"

import "./create-password.vue?vue&type=style&index=0&id=79cf9a48&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79cf9a48"]])

export default __exports__